<section class="companies-page">
  <!-- Caminho padrão do Cognito (Dashboard > Empresas > Societário). -->
  <header class="top-bar">
    <app-breadcrumb class="top-bar__crumbs" [home]="breadcrumbHome" [items]="breadcrumbs" />
    <h1 class="sr-only">Societário</h1>
  </header>

  <div class="sub-bar">
    <p class="sub-bar__hint">
      Situação do contrato social de cada empresa, lido pelo Cog a partir do Data Room.
    </p>
    <div class="sub-bar__filters">
      <div class="sub-bar__search">
        <app-search
          [value]="search()"
          [realTime]="true"
          [isLoading]="loading()"
          [placeholder]="'Buscar por nome ou CNPJ'"
          (sendSearch)="onSearch($event)"></app-search>
      </div>
      <app-select
        class="sub-bar__status"
        [theme]="'medium'"
        [hasFilter]="false"
        [options]="statusOptions"
        [ngModel]="status()"
        (ngModelChange)="onStatusChange($event)" />
    </div>
  </div>

  @if (loadFailed()) {
    <div class="state">
      <i class="pi pi-exclamation-triangle state__icon state__icon--error" aria-hidden="true"></i>
      <p class="state__title">Não foi possível carregar a lista.</p>
      <button type="button" class="bar-btn" (click)="retry()">
        <i class="pi pi-refresh" aria-hidden="true"></i>Tentar de novo
      </button>
    </div>
  } @else if (!loading() && !items().length) {
    <div class="state">
      <i class="pi pi-building state__icon" aria-hidden="true"></i>
      @if (hasFilter()) {
        <p class="state__title">Nenhuma empresa com esses filtros.</p>
        <button type="button" class="bar-btn" (click)="clearFilters()">
          <i class="pi pi-filter-slash" aria-hidden="true"></i>Limpar filtros
        </button>
      } @else {
        <p class="state__title">Nenhuma empresa no seu escopo.</p>
        <p class="state__text">As empresas aparecem aqui assim que forem cadastradas.</p>
      }
    </div>
  } @else {
    <app-charter-companies-table
      [items]="items()"
      [loading]="loading()"
      (openCompany)="openCompany($event)"
      (sendCharter)="openDataRoom($event)" />

    @if (!loading() && pages() > 1) {
      <nav class="pager" aria-label="Paginação">
        <span class="pager__range">{{ rangeLabel() }}</span>
        <button
          type="button"
          class="bar-btn"
          title="Página anterior"
          [disabled]="page() <= 1"
          (click)="goToPage(page() - 1)">
          <i class="pi pi-angle-left" aria-hidden="true"></i>
        </button>
        <span class="pager__page">{{ page() }} / {{ pages() }}</span>
        <button
          type="button"
          class="bar-btn"
          title="Próxima página"
          [disabled]="page() >= pages()"
          (click)="goToPage(page() + 1)">
          <i class="pi pi-angle-right" aria-hidden="true"></i>
        </button>
      </nav>
    } @else if (!loading() && total()) {
      <p class="pager__range pager__range--alone">{{ rangeLabel() }}</p>
    }
  }
</section>
